<template>
  <div class="cash-withdrawal">
    <div class="nav acea-row">
      <div
        v-for="(item, index) in navList"
        class="item font-color-red"
        @click="swichNav(index, item)"
        v-show="item.name != '微信'"
        :key="index"
      >
        <div
          class="line bg-color-red"
          :class="currentTab === index ? 'on' : ''"
        ></div>
        <div
          class="iconfont"
          :class="item.icon + ' ' + (currentTab === index ? 'on' : '')"
        ></div>
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div class="wrapper">
      <div :hidden="post.extract_type !== 'bank'" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">持卡人</div>
          <div class="input">
            <input placeholder="请输入持卡人姓名" v-model="post.name" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">卡号</div>
          <div class="input">
            <input placeholder="请填写卡号" v-model="post.cardnum" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">银行</div>
          <div class="input">
            <select v-model="post.bankname">
              <option value="">请选择银行</option>
              <option
                v-for="(item, index) in banks"
                :key="index"
                :value="item"
                >{{ item }}</option
              >
            </select>
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
        <!-- <div class="tip">当前可提现金额: {{ lsjf }}</div>
        <div class="bnt bg-color-red" @click="submitted">提现</div> -->
      </div>
      <div :hidden="post.extract_type !== 'weixin'" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">微信号</div>
          <div class="input">
            <input placeholder="请输入微信号" v-model="post.weixin" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
        <div class="tip">当前可提现金额: {{ lsjf }}</div>
        <div class="bnt bg-color-red" @click="submitted">提现</div>
      </div>
      <div :hidden="post.extract_type !== 'alipay'" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">用户名</div>
          <div class="input">
            <input placeholder="请填写您的支付宝用户名" v-model="post.name" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">账号</div>
          <div class="input">
            <input
              placeholder="请填写您的支付宝账号"
              v-model="post.alipay_code"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">提现</div>
          <div class="input">
            <input
              :placeholder="'最低提现金额' + minPrice"
              v-model="post.money"
            />
          </div>
        </div>
      </div>
      <div class="list">
        <!-- <div class="item acea-row row-between-wrapper">
          <div class="name">验证码</div>
          <div class="input acea-row row-between-wrapper">
            <input
              type="text"
              style="width:30vw;"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div> -->
        <div class="item acea-row row-between-wrapper">
          <div class="name">交易密码</div>
          <div class="input">
            <input
              type="password"
              placeholder="请填写您的交易密码"
              v-model="post.pwd"
            />
          </div>
        </div>
        <div class="tip" v-if="type == 'mjf_sj'">
          当前可提现金额: {{ mjf_sj }}
        </div>
        <div class="tip" v-else>当前可提现金额: {{ lsjf }}</div>
        <div class="bnt bg-color-red" @click="submitted">提现</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getBank,
  postCashInfo,
  getCodeApi,
  registerVerify
} from "../../../api/user";
import { required } from "@utils/validate";
import { mapGetters } from "vuex";
import { validatorDefaultCatch } from "@utils/dialog";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { VUE_APP_API_URL } from "@utils";
export default {
  name: "UserCash",
  components: {},
  mixins: [sendVerifyCode],
  props: {},
  computed: mapGetters(["userInfo"]),
  data: function() {
    return {
      captcha: "",
      navList: [
        { name: "支付宝", type: "alipay", icon: "icon-icon34" },
        { name: "微信", type: "weixin", icon: "icon-weixin2" },
        { name: "银行卡", type: "bank", icon: "icon-yinhangqia" }
      ],
      post: {
        extract_type: "alipay",
        alipay_code: "",
        money: "",
        name: "",
        bankname: "",
        cardnum: "",
        weixin: "",
        pwd: ""
      },
      currentTab: 0,
      minPrice: 0,
      banks: [],
      keyCode: "",
      lsjf: 0,
      type: "",
      mjf_sj: 0
    };
  },
  mounted: function() {
    this.type = this.$route.query.type;
    this.getCode();
    this.getBank();
  },
  methods: {
    async code() {
      var that = this;
      await registerVerify({
        phone: that.userInfo.phone_copy,
        type: "",
        key: that.keyCode
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    swichNav: function(index, item) {
      this.currentTab = index;
      this.post.extract_type = item.type;
    },
    getBank: function() {
      let that = this;
      getBank().then(
        res => {
          that.banks = res.data.extractBank;
          that.minPrice = res.data.minPrice;
          that.lsjf = res.data.lsjf;
          that.mjf_sj = res.data.mjf_sj;
        },
        function(err) {
          that.$dialog.message(err.msg);
        }
      );
    },
    async submitted() {
      let bankname = this.post.bankname,
        alipay_code = this.post.alipay_code,
        captcha = this.captcha,
        money = this.post.money,
        name = this.post.name,
        cardnum = this.post.cardnum,
        weixin = this.post.weixin,
        bz_type = this.type,
        that = this;
      if (
        (parseFloat(money) > parseFloat(that.lsjf) ||
          parseFloat(that.lsjf) == 0) &&
        that.type == "lsjf"
      )
        return that.$dialog.message("余额不足");
      if (
        (parseFloat(money) > parseFloat(that.mjf_sj) ||
          parseFloat(that.mjf_sj) == 0) &&
        that.type == "mjf_sj"
      )
        return that.$dialog.message("余额不足");
      if (parseFloat(money) < parseFloat(that.minPrice))
        return that.$dialog.message("最低提现金额" + that.minPrice);
      switch (that.post.extract_type) {
        case "bank":
          try {
            await this.$validator({
              name: [required.message("持卡人姓名")],
              cardnum: [required(required.message("卡号"))],
              bankname: [required(required("请选择提现银行"))],
              money: [required.message("提现金额")]
            }).validate({ bankname, cardnum, name, money });
            let save = {
              extract_type: that.post.extract_type,
              bankname: bankname,
              captcha: captcha,
              cardnum: cardnum,
              name: name,
              money: money,
              bz_type: bz_type
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "alipay":
          try {
            await this.$validator({
              name: [required(required.message("支付宝用户名"))],
              alipay_code: [required(required.message("支付宝账号"))],
              money: [required(required.message("提现金额"))]
            }).validate({ name, alipay_code, money });
            let save = {
              extract_type: that.post.extract_type,
              alipay_code: alipay_code,
              name: name,
              captcha: captcha,
              money: money,
              bz_type: bz_type
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "weixin":
          try {
            await this.$validator({
              weixin: [required(required.message("提现微信号"))],
              money: [required(required.message("提现金额"))]
            }).validate({ weixin, money });
            let save = {
              extract_type: that.post.extract_type,
              weixin: weixin,
              captcha: captcha,
              money: money,
              bz_type: bz_type
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
      }
    },
    save: function(info) {
      if (!this.post.pwd) return this.$dialog.toast({ mes: "请输入交易密码!" });
      info["pwd_pay"] = this.post.pwd;
      postCashInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/audit" });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
